import { UseToastOptions } from '@chakra-ui/react'

export const TOAST_DEFUALT_OPTIONS: UseToastOptions = {
  variant: 'solid',
  isClosable: true,
  duration: 2500,
  position: 'top-right',
  containerStyle: { w: { base: '10px', sm: '100%' } },
}
